import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DashboardComponent } from './dashboard.component';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { SidenavModule } from 'src/app/layout/sidenav/sidenav.module';
import { FurySharedModule } from 'src/@fury/fury-shared.module';

@NgModule({
  declarations: [DashboardComponent],
  imports: [CommonModule, RouterModule, MatIconModule, SidenavModule, FurySharedModule]
})
export class DashboardModule {}
